/*** IMPORTS FROM imports-loader ***/
var define = false;

var WeakMap = require('./_WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;

